import { FC, Fragment } from "react";

import { ChevronUpDownIcon } from "@heroicons/react/20/solid";
import { classNames } from "@/shared/utils/classnames";
import { ListboxButton } from "@headlessui/react";

export type ButtonSelectprops = {
  nameSelected: string;
  error?: string;
  disabled?: boolean;
};

export const ButtonSelect: FC<ButtonSelectprops> = ({
  nameSelected,
  error,
  disabled,
}) => {
  return (
    <Fragment>
      <ListboxButton
        disabled={disabled}
        className={classNames(
          "relative w-full cursor-default rounded-md bg-white py-1.5 pl-3 pr-10 text-left text-gray-400 shadow-sm ring-1 ring-inset sm:text-sm sm:leading-6",
          error
            ? "ring-red-300 placeholder:text-red-300"
            : "ring-gray-300 focus:outline-none focus:ring-2 focus:ring-primary",
          disabled
            ? "disabled:cursor-not-allowed disabled:bg-gray-100 disabled:text-gray-500 disabled:ring-gray-200"
            : ""
        )}
      >
        <span className="block truncate">{nameSelected}</span>
        <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
          <ChevronUpDownIcon
            aria-hidden="true"
            className="h-5 w-5 text-gray-400"
          />
        </span>
      </ListboxButton>
    </Fragment>
  );
};
